class StickyAtc extends HTMLElement {
  connectedCallback() {
    const targetSelector = this.dataset.target || 'add-to-cart-component, button[name="add"], product-form-component button[type="submit"]';
    const original = document.querySelector(targetSelector);
    if (!original) {
      this.remove();
      return;
    }
    const sentinel = original.closest('product-form-component, .product-form, .product-information__details') || original;
    const button = this.querySelector('[data-sticky-atc-trigger]');
    if (button) {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        original.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const focusable = original.matches('button') ? original : original.querySelector('button');
        if (focusable) {
          window.setTimeout(() => focusable.focus({ preventScroll: true }), 320);
        }
      });
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.removeAttribute('visible');
        } else {
          this.setAttribute('visible', '');
        }
      },
      { rootMargin: '0px 0px 0px 0px', threshold: 0 }
    );
    observer.observe(sentinel);
    this._observer = observer;
    this._sentinel = sentinel;
  }

  disconnectedCallback() {
    if (this._observer && this._sentinel) {
      this._observer.unobserve(this._sentinel);
    }
  }
}

if (!customElements.get('sticky-atc-component')) {
  customElements.define('sticky-atc-component', StickyAtc);
}
